import React from "react";

export type FindingContext = "present" | "absent" | "unknown";

export const EntityContextWrapper =
  React.createContext<FindingContext>("present");
